import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { request } from "@/utils/api";

// Async thunk for fetching wallet balance
export const fetchWalletBalance = createAsyncThunk(
    "wallet/fetch",
    async (_, { rejectWithValue }) => {
        try {
            const response = await request({
                endpoint: "/user/wallet/balance",
                method: "GET"
            });

            if (!response.data) {
                return rejectWithValue(response.message || "Failed to fetch wallet balance.");
            }

            return response.data;
        } catch ({ error }) {
            console.error("Error fetching wallet balance:", error.message);
            return rejectWithValue(error.message || "An unexpected error occurred while fetching wallet balance.");
        }
    }
);

// Async thunk for updating wallet balance
export const updateWalletBalance = createAsyncThunk(
    "wallet/update",
    async (data, { rejectWithValue }) => {
        try {
            const response = await request({
                endpoint: "/user/wallet/balance",
                method: "POST",
                data
            });

            if (!response.data) {
                return rejectWithValue(response.message || "Failed to update wallet balance.");
            }

            return response.data;
        } catch ({ error }) {
            console.error("Error updating wallet balance:", error.message);
            return rejectWithValue(error.message || "An unexpected error occurred while updating wallet balance.");
        }
    }
);

const initialState = {
    balance: 0,
    loading: false,
    error: null,
    lastUpdated: null
};

const walletSlice = createSlice({
    name: "wallet",
    initialState,
    reducers: {
        setBalance: (state, action) => {
            state.balance = action.payload;
            state.lastUpdated = new Date().toISOString();
        },
        resetWallet: (state) => {
            state.balance = 0;
            state.loading = false;
            state.error = null;
            state.lastUpdated = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchWalletBalance.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchWalletBalance.fulfilled, (state, action) => {
                state.loading = false;
                state.balance = action.payload;
                state.lastUpdated = new Date().toISOString();
            })
            .addCase(fetchWalletBalance.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to fetch wallet balance";
            })
            .addCase(updateWalletBalance.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateWalletBalance.fulfilled, (state, action) => {
                state.loading = false;
                state.balance = action.payload;
                state.lastUpdated = new Date().toISOString();
            })
            .addCase(updateWalletBalance.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to update wallet balance";
            });
    }
});

export const { setBalance, resetWallet } = walletSlice.actions;
export default walletSlice.reducer;